import { makeStyles, MenuItem } from "@material-ui/core";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import React, { useState } from "react";
import { error } from "../../../../store/notification/actions";
import MenuTableCell from "../../base/views/MenuTableCell";
import { GetRole, GetStoresUserLicense } from "./Helper/activeUserHelper";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  filed: {
    margin: "1vw",
  },
  bg: {
    display: "flex",
    justifyContent: "flex-start",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    maxWidth: 300,
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
  icon: {
    borderRadius: "50%",
    width: 16,
    height: 16,
    boxShadow:
      "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    backgroundColor: "#f5f8fa",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
    "$root.Mui-focusVisible &": {
      outline: "2px auto rgba(19,124,189,.6)",
      outlineOffset: 2,
    },
    "input:hover ~ &": {
      backgroundColor: "#ebf1f5",
    },
    "input:disabled ~ &": {
      boxShadow: "none",
      background: "rgba(206,217,224,.5)",
    },
  },
  checkedIcon: {
    backgroundColor: "#137cbd",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&:before": {
      display: "block",
      width: 16,
      height: 16,
      backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
      content: '""',
    },
    "input:hover ~ &": {
      backgroundColor: "#106ba3",
    },
  },
}));

export default function AddUserLicense(props) {
  const classes = useStyles();
  const [roleData, setRoleData] = useState([]);
  const [availableStores, setAvailableStores] = useState([]);
  const { addUserData, updateRoles } = props;
  React.useEffect(() => {
    GetRole()
      .then((response) => {
        setRoleData(response);
      })
      .catch((err) => {});
    GetStoresUserLicense(
      addUserData.selectstores.map((store) => store.storeid)
    ).then((res) => {
      setAvailableStores(res.data);
    });
    //eslint-disable-next-line
  }, []);

  const handleStatusChange = (e, storepk, licenseavailable) => {
    updateRoles({ ...e.target.value, storepk, licenseavailable });
  };

  return (
    <div>
      <h2>Assign Roles</h2>
      <Container component="main" maxWidth="lg">
        <Grid
          container
          spacing={3}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>User</TableCell>
                <TableCell>Pharmacy</TableCell>
                <TableCell>Available License</TableCell>
                <TableCell>Role</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {addUserData.selectstores.map((row, i) => {
                const s = availableStores.find(
                  (store) => store.storeid === row.storeid
                );
                const licenseavailable = s
                  ? s.licenseavailabe - s.licenseused
                  : "";
                if (licenseavailable === 0)
                  error(
                    "The selected store is out of license. Please purchase new License or deactivate any active user."
                  );
                return (
                  <TableRow key={i}>
                    <TableCell>
                      {`${addUserData.firstname} ${addUserData.lastname}`}
                    </TableCell>
                    <TableCell>{row.storename}</TableCell>
                    <TableCell>{licenseavailable}</TableCell>
                    <MenuTableCell
                      disabled={licenseavailable === 0}
                      onChange={(e) => {
                        handleStatusChange(e, row.storepk, licenseavailable);
                      }}
                    >
                      {roleData.map((role, j) => (
                        <MenuItem key={j} value={role}>
                          {role.roletype}
                        </MenuItem>
                      ))}
                    </MenuTableCell>
                    <TableCell component="th" scope="row">
                      {row.name}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Grid>
      </Container>
    </div>
  );
}
